(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("ext/dhtmlxgantt_tooltip", [], factory);
	else if(typeof exports === 'object')
		exports["ext/dhtmlxgantt_tooltip"] = factory();
	else
		root["ext/dhtmlxgantt_tooltip"] = factory();
})(window, function() {
return 